import React, { useState, useEffect } from 'react';

interface PatternMemoryActivityProps {
  timeLeft: number;
  onInteraction: (data: any) => void;
}

export function PatternMemoryActivity({ timeLeft, onInteraction }: PatternMemoryActivityProps) {
  const [pattern, setPattern] = useState<number[]>([]);
  const [userPattern, setUserPattern] = useState<number[]>([]);
  const [showingPattern, setShowingPattern] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    // Generate initial pattern
    const newPattern = Array.from({ length: 3 }, () => Math.floor(Math.random() * 4));
    setPattern(newPattern);
    setShowingPattern(true);

    setTimeout(() => setShowingPattern(false), 3000);
  }, []);

  const handleSquareClick = (index: number) => {
    if (showingPattern) return;

    const newUserPattern = [...userPattern, index];
    setUserPattern(newUserPattern);
    onInteraction({ type: 'pattern_click', index, timestamp: Date.now() });

    if (newUserPattern.length === pattern.length) {
      const isCorrect = newUserPattern.every((val, i) => val === pattern[i]);
      setTimeout(() => {
        setUserPattern([]);
        if (isCorrect) {
          // Generate new, longer pattern
          const nextPattern = Array.from({ length: pattern.length + 1 }, () => Math.floor(Math.random() * 4));
          setPattern(nextPattern);
          setShowingPattern(true);
          setTimeout(() => setShowingPattern(false), 3000);
        }
      }, 1000);
    }
  };

  return (
    <div className="text-center">
      <p className="text-lg font-semibold text-purple-700 mb-6 font-baloo">
        {showingPattern ? "Watch the pattern! 🧠" : "Now repeat the pattern! 🎯"}
      </p>
      <div className="grid grid-cols-2 gap-4 max-w-xs mx-auto">
        {[0, 1, 2, 3].map((index) => (
          <button
            key={index}
            onClick={() => handleSquareClick(index)}
            className={`w-20 h-20 rounded-xl transition-all duration-200 ${
              showingPattern && pattern[currentStep] === index
                ? 'bg-purple-500 scale-110 shadow-lg'
                : userPattern.includes(index)
                ? 'bg-purple-300'
                : 'bg-purple-100 hover:bg-purple-200'
            }`}
            disabled={showingPattern}
          >
            <div className="w-full h-full rounded-xl border-2 border-purple-300"></div>
          </button>
        ))}
      </div>
    </div>
  );
}
